export default function interopDefault(m) {
  return m.default || m;
}
